<template>
  <div>
    <SearchField
      :form="formInline"
      :formCtrl="formCtrl"
      @onSearch="onSearch"
      @onReset="onReset"
      @onChange="onSearchItemChange"
    >
      <!-- 添加按钮 -->
      <template #start>
        <el-form-item v-if="user && [1, 5].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" icon="el-icon-plus" @click="addOrder">添加</el-button>
        </el-form-item>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate
          ref="comFormDate"
          :type="'daterange'"
          :options="searchDateOptions"
          @onChange="onComSearchChange"
        >
        </CompositeFormDate>
      </template>
      <!-- 复合搜索框 -->

      <template #beforeBtn>
        <CompositeFormCtrl
          ref="comFormCtrl"
          :options="searchKeyOptions"
          @onChange="onComSearchChange"
        >
        </CompositeFormCtrl>
      </template>
      <template #end>
        <!-- 导出按钮 -->
        <el-form-item
          class="endBtn"
          v-if="user && [1, 2, 3, 4, 5].includes(user.user_group_id)"
        >
          <el-button
            type="primary"
            icon="el-icon-download"
            @click="Export(`普通订单_自有车辆`)"
            >导出</el-button
          >
        </el-form-item>
        <!-- 过磅单导出 -->
        <el-form-item
          class="endBtn"
          v-if="user && [1, 2, 3, 4, 5].includes(user.user_group_id)"
        >
          <el-button
            class="exportBtn"
            type="primary"
            :loading="btnloading"
            @click="showDialog()"
          >
            <i v-if="!btnloading" class="el-icon-folder"></i>
            导出
          </el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table
      ref="table"
      :tableHeight="tableHeight"
      :tableData="tableData"
      :cols="cols"
      :page="page"
      :limit="limit"
      :total="total"
      :showIndex="true"
      :btns="btns"
      :allBtnWidth="allBtnWidth"
      @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"
    >
      <template slot="isvoice" slot-scope="params">
        <MySwitch
          :data="params.params"
          :activeValue="'2'"
          :inactiveValue="`1`"
          @onToggle="toggleDisplay"
        ></MySwitch>
      </template>

      <template slot="times" slot-scope="params">
        <div v-if="params.params.times == 0" class="overTime type0">即将到期</div>
        <div v-if="params.params.times == 1" class="overTime type1">暂未到期</div>
        <div v-if="params.params.times == 2" class="overTime type2">已逾期</div>
      </template>
    </Table>

    <!-- 批量导出弹窗 -->
    <Dialog class="dialog" ref="dialog" :title="title" @closed="onClose">
      <template #default>
        <el-form class="searchForm" :model="mform">
          <div class="row">
            <FormItem
              v-for="(c, i) in mformCtrl.slice(0, 3)"
              :key="`mformItem_${c.keyName}_${i}_${c.disabled}`"
              :viewMode="false"
              :config="c"
              :options="c.options"
              :inputValue="mform[c.keyName]"
              @onChange="onModalFormChange"
            />
          </div>

          <div class="row">
            <FormItem
              v-for="(c, i) in mformCtrl.slice(3)"
              :key="`mformItem_${c.keyName}_${i}_${c.disabled}`"
              :viewMode="false"
              :config="c"
              :options="c.options"
              :inputValue="mform[c.keyName]"
              @onChange="onModalFormChange"
            />

            <FormItem
              v-for="(c, i) in modalSearchFormCtrl"
              :key="`formItem_${c.keyName}_${i}_${!!c.disabled}`"
              :viewMode="false"
              :config="c"
              :inputValue="modalSearchForm[c.keyName]"
              @onChange="onSearchFormChange"
            />

            <el-form-item>
              <el-button type="primary" @click="getCars">搜索</el-button>
            </el-form-item>

            <el-form-item>
              <el-button plain @click="onModalSearchReset">重置</el-button>
            </el-form-item>

            <el-form-item>
              <el-button plain @click="onClose">全部重置</el-button>
            </el-form-item>
          </div>
        </el-form>

        <el-scrollbar class="content">
          <CarList ref="carlist" :list="modalList" @onCheckChange="onCheckChange" />
        </el-scrollbar>

        <div class="btns">
          <el-button type="primary" @click="onModalSubmit">确 认</el-button>
          <el-button @click="onModalCancel">取 消</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../../../contract/own/mixin";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: "order",
      formInline: {
        ischeck: 1,
        isstatus: 4,
      },
      formCtrl: [
        {
          label: "装货地址",
          keyName: "coaddress",
          placeholder: "请输入装货地址",
          type: "text",
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          placeholder: "请输入卸货地址",
          type: "text",
        },
        {
          label: "过磅单：",
          keyName: "isvoice",
          type: "select",
          options: [
            { label: "未回收", value: 1 },
            { label: "已回收", value: 2 },
          ],
        },
        {
          label: "逾期状态：",
          keyName: "intimes",
          type: "select",
          options: [
            { label: "未到期", value: 1 },
            { label: "已到期", value: 2 },
            { label: "快到期", value: 3 },
          ],
        },
      ],
      cols: [
        { prop: "order_num", label: "订单编号", width: 150 },
        { prop: "fleet_nickname", label: "车队长" },
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机", minwidth: 120 },
        { prop: "name", label: "货物名称", minwidth: 120 },
        { prop: "shname", label: "客户名称" },
        { prop: "coaddress", label: "装货地址" },
        { prop: "enaddress", label: "卸货地址" },
        { prop: "starttime", label: "装货日期", width: 120 },
        { prop: "edittime", label: "卸货日期", width: 120 },
        {
          prop: "inton",
          label: "装货重量",
          align: "right",
          className: "pr30",
          width: 120,
        },
        {
          prop: "unton",
          label: "卸货重量",
          align: "right",
          className: "pr30",
          width: 120,
        },
        {
          prop: "cprice",
          label: "公司单价",
          align: "right",
          className: "pr30",
          width: 120,
        },
        {
          prop: "dprice",
          label: "司机单价",
          align: "right",
          className: "pr30",
          width: 120,
        },
        { prop: "isvoice", label: "回收过磅单", slot: "isvoice", width: 120 },
        { prop: "times", label: "是否逾期", slot: "times" },
      ],
      allBtnWidth: "138px",
      btns: [
        {
          ...this.feeBtn,
          cb: ({ id, isstatus }) => {
            console.log(id);
            let mode = "view";
            const { user_group_id } = this.user;
            if (isstatus == 4 && user_group_id == 1 && this.user.id == 1) {
              mode = "edit";
            }
            this.$router.push(`/order/nocontractfee?id=${id}&mode=${mode}`);
          },
        },
        {
          ...this.viewBtn,
          title: "查看",
          cb: ({ id, isstatus, isover }) => {
            console.log(id, isstatus, isover);
            let path = "nocontractview41";
            let mode = "view";
            if ([1].includes(this.user.id)) {
              path = "nocontractview4";
              mode = "edit";
            }
            this.$router.push(`/order/${path}?id=${id}&mode=${mode}`);
          },
        },
      ],
    };
  },
  methods: {
    addOrder() {
      this.$router.push("/order/nocontractadd");
    },
    tableDataHandler({ count, data }) {
      this.total = count;
      if (data && data.length) {
        this.tableData = data.map((v) => {
          const o = this.dataObjHandler(v);
          o.open = v.isvoice + "";
          return o;
        });
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id }) {
      let url = `order/upstatus`;
      const params = {
        // userid: this.user.id,
        id,
      };
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg === "success") {
            this.$message({
              type: "success",
              message: "提交成功!",
            });
            this.getList(true);
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "提交失败，请稍后重试！",
          });
        }
      );
    },
  },
  mounted() {
    const { user_group_id, id } = this.user;
    if ([1].includes(user_group_id) && id == 1) {
      this.allBtnWidth = 180;
      this.btns.push({
        ...this.editBtn,
        cb: ({ id }) => {
          this.$router.push(`/order/nocontractdetaildone?id=${id}&mode=edit`);
        },
      });
      this.btns.push({
        ...this.delBtn,
        cb: ({ order_num }) => {
          this.delete(order_num);
        },
      });
    }
    if ([5].includes(user_group_id)) {
      this.cols.length = 11;
      this.btns.length = 2;
      this.allBtnWidth = "112px";
      this.btns[1].cb = ({ id }) => {
        this.$router.push(`/order/nocontractview41?id=${id}&mode=view`);
      };
    }
    if ([2, 3, 4].includes(user_group_id)) {
      this.btns.length = 2;
      this.allBtnWidth = 100;
      this.btns[1].cb = ({ id }) => {
        this.$router.push(`/order/nocontractview41?id=${id}&mode=view`);
      };
    }

    this.getCars();
  },
};
</script>

<style lang="less" scoped>
/deep/ .retrieval {
  .el-form--inline {
    .startBtn {
      margin-right: 25px;
    }

    .el-form-item:last-of-type {
      margin-right: 0;
    }
  }
}

.table-wrap {
  /deep/ .el-table {
    .el-switch {
      &.inactive {
        .el-switch__core::after {
          content: "否";
          line-height: 17px;
          text-indent: 18px;
          color: #fff;
        }
      }

      &.active {
        .el-switch__core::after {
          content: "是";
          line-height: 17px;
          text-indent: -34px;
          color: #fff;
        }
      }
    }

    .overTime {
      // width: 14px;
      // height: 14px;
      // border-radius: 100%;
      // display: inline-block;
      // vertical-align: top;
      // margin-top: 7px;
      color: #ffe100;

      &.type1 {
        color: #98e098;
      }

      &.type2 {
        color: #fd5b5b;
      }
    }
  }
}

/deep/ .el-button.is-circle {
  padding: 5px;
  color: #96999f;
  background: #f2f6fc;
}

.dialog {
  /deep/ .el-dialog {
    width: 931px;
  }

  .searchForm {
    .row {
      display: flex;
    }

    /deep/ .el-form-item {
      margin: 0;
      margin-bottom: 20px;

      .el-form-item__content {
        .el-input {
          input {
            background: #fff;
          }
        }
      }

      &:not(:first-of-type) {
        margin-left: 15px;
      }
    }
  }

  .content {
    height: 380px;

    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    /deep/ .is-horizontal {
      display: none;
    }
  }

  .btns {
    text-align: center;
    margin-left: 0;
  }
}
</style>
